import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { MonitoringProductData } from "@domain/project/monitoring-product-data/monitoring-product-data";
import {
  getAdditionalProductsTableDraftQuantity,
  getAdditionalProductsTableProductQuantity,
} from "@domain/project/product-list/additional-products-display.util";
import { AdditionalConfigDisplayData } from "@domain/project/product-list/product-list-display-data.util";
import { TooltipDirective } from "@odx/angular/components/tooltip";

@Component({
  selector: "app-monitoring-additional-products-table",
  imports: [CommonModule, UiKitModule, TooltipDirective],
  templateUrl: "./monitoring-additional-products-table.component.html",
  styleUrl: "./monitoring-additional-products-table.component.scss",
  standalone: true,
})
export class MonitoringAdditionalProductsTableComponent {
  @Input({ required: true }) configs: AdditionalConfigDisplayData<MonitoringProductData>[] = [];
  @Input() editMode = false;
  @Input() draftQuantities: Record<string, number> = {};
  @Input() emptyMessage = "";

  @Output() quantityChange = new EventEmitter<{ configId: string; value: number | string }>();
  @Output() quantityStep = new EventEmitter<{ configId: string; delta: number }>();
  @Output() remove = new EventEmitter<string>();

  protected readonly tooltipTextWarningSign: string = $localize`:@@productlist.table.warningSign.tooltip:Produkt enthält abgekündigte Komponenten oder ist Teil einer unvollständigen Konfiguration`;

  protected getDraftQuantity(config: AdditionalConfigDisplayData<MonitoringProductData>) {
    return getAdditionalProductsTableDraftQuantity(this.editMode, this.draftQuantities, {
      config: {
        id: config.configId,
        additionalProductListQuantity: config.savedQuantity,
      },
    });
  }

  protected getProductQuantity(product: MonitoringProductData, config: AdditionalConfigDisplayData<MonitoringProductData>) {
    return getAdditionalProductsTableProductQuantity(this.editMode, this.draftQuantities, product, {
      config: {
        id: config.configId,
        additionalProductListQuantity: config.savedQuantity,
      },
    });
  }

  protected updateAdditionalProductQuantity(configId: string, delta: number) {
    this.quantityStep.emit({ configId, delta });
  }

  protected setAdditionalProductQuantity(configId: string, value: number | string) {
    this.quantityChange.emit({ configId, value });
  }

  protected removeAdditionalProduct(configId: string) {
    this.remove.emit(configId);
  }
}
